import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '@shared-app-config';
import { TranslatePipe } from '@ngx-translate/core';
import { WebLogo } from '../web-logo/web-logo';
import { LANDING_CONTACTS } from '../_utils/landing-contacts';

@Component({
  selector: 'fr8bot-web-footer',
  templateUrl: './web-footer.html',
  styleUrl: './web-footer.scss',
  imports: [TranslatePipe, WebLogo],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebFooter {
  protected readonly environment = environment;
  protected readonly contacts = LANDING_CONTACTS;
  privacyPolicyUrl = `${environment.frontendUrl.login}/privacy-policy`;
}
